
import ContactSection from '../section';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ExternalLink from '@/ui-kit/components/external-link';

export default {
  name: 'ContactCards',
  components: {
    ContactSection,
    ExternalLink,
  },
  props: {
    storeName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      StyleColorSchemeType,
    };
  },
  computed: {
    content() {
      return this.$store.state[this.storeName].contactContent;
    },
  },
};
